import './App.css';
import { useState } from 'react';

import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import DataView from './components/DataView';

function App() {  
  return (
    <div className="App">
    <Router>
      <Routes>
        <Route path='/phase_1' element={<DataView />} />
        <Route path='/phase_2' element={<DataView />} />
        <Route path="/*" element={<Navigate to="/phase_1" />} />
      </Routes>
    </Router>
    </div>
  );
}

export default App;
